import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { styled } from 'goober';

import { useProjectListingsSectionParams } from '@/features/projects/project-listings/use-project-listings-section-params';
import { paths } from '@/routes/helpers/paths';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { RouteLink } from '@/ui/link/route-link';
import { Stack } from '@/ui/line/line';
import { TableSecondaryCell } from '@/ui/table/infinite-table/table-cells';

import { ListStatusTag } from '../../list-status-tag/list-status-tag';

interface RelatedProjectRowProps {
  disableLinks?: boolean;
  listingsCount: number;
  projectId: string;
  projectName: string;
  stage: string;
}

export const RelatedProjectRow = ({
  disableLinks = false,
  listingsCount,
  projectId,
  projectName,
  stage,
}: RelatedProjectRowProps) => {
  const { t } = useTranslation('teams');
  const listingsSectionParams = useProjectListingsSectionParams();

  const projectPath = {
    pathname: paths.project({
      projectId,
    }),
    search: listingsSectionParams,
  };

  return (
    <Row>
      <Flexbox
        alignItems="center"
        fullWidth
        gap="20px"
        justify="space-between"
        name="related-project-row-container"
      >
        <Stack gap="0px">
          {disableLinks ? (
            <>
              <ProjectName>{projectName}</ProjectName>
              <TableSecondaryCell>
                {listingsCount} {t`companies`}
              </TableSecondaryCell>
            </>
          ) : (
            <>
              <ProjectLink to={projectPath}>{projectName}</ProjectLink>
              <TableSecondaryCell>
                <Link to={projectPath}>
                  {listingsCount} {t`companies`}
                </Link>
              </TableSecondaryCell>
            </>
          )}
        </Stack>
        {stage === '' ? '-' : <ListStatusTag text={stage} />}
      </Flexbox>
    </Row>
  );
};
const Row = styled('div')`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.c2};
  padding: 16px 5px;
  width: 100%;
`;

const ProjectName = styled('div')`
  ${({ theme }) => theme.typography.acrossPlatform.minimizedHeader}
  ${({ theme }) => theme.mixins.ellipsis}
  max-width: 500px;
`;

const ProjectLink = styled(RouteLink)`
  ${({ theme }) => theme.typography.acrossPlatform.minimizedHeader}
  ${({ theme }) => theme.mixins.ellipsis}
  text-decoration: none;
  max-width: 500px;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
